module.exports = __webpack_public_path__ + "img/ai-tic-tac-toe-3.a15b7944.png";